import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
} from '../ApiService';

export default {
  getApiName() {
    return 'cars';
  },

  getItems(p = 1, params) {
    return apiGet(`/cars?page=${p}`, { params })
      .then(response => ({
        data: response.data.docs.map(car => ({
          id: car._id,
          name: `Марка: ${car.mark}, Номер: ${car.number}`,
          ...car,
        })),
        records: response.data.pages.allRecords,
      }))
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  getById(id) {
    return apiGet(`/car/${id}`)
      .then((response) => {
        const result = {
          id: response.data._id,
          name: `${response.data.mark}; ${response.data.number}`,
          relations: [],
          inputs: [],
          checkboxes: [],
        };

        result.inputs.push({
          title: 'Марка автомобиля',
          name: 'mark',
          value: response.data.mark,
        });

        result.inputs.push({
          title: 'Номер автомобиля',
          name: 'number',
          value: response.data.number,
        });

        return result;
      })
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  removeLinkedItem() {
    return null;
  },

  addLinkedItem() {
    return null;
  },

  deleteItem(id) {
    return apiDelete(`/car/${id}`)
      .then(response => response)
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  getFields() {
    return {
      relations: [],
      inputs: [
        {
          title: 'Марка автомобиля',
          name: 'mark',
        },
        {
          title: 'Номер автомобиля',
          name: 'number',
        },
      ],
      checkboxes: [],
    };
  },

  updateItem(id, body) {
    return apiPut(`/car/${id}`, body)
      .then(response => response)
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  createItem(body) {
    return apiPost('/car', body)
      .then(response => ({
        status: response.status,
        data: {
          id: response.data._id,
          name: `Марка: ${response.data.mark}, Номер: ${response.data.number}`,
          ...response.data,
        },
      }))
      .catch((error) => {
        console.log('error', error);
        throw new Error(error.response.data.error.message);
      });
  },

  searchItem(body) {
    return apiGet(`/cars?search=${body.search}`)
      .then(response => response.data.docs.map(car => ({
        id: car._id,
        name: `Марка: ${car.mark}, Номер: ${car.number}`,
        ...car,
      })))
      .catch(error => console.log('Not Search', error));
  },
};
